<mat-tab-group mat-stretch-tabs="false" (selectedTabChange)="tabClick($event)" [selectedIndex]="tabIndex" animationDuration="0ms" class="square">
  <!--  <ng-container>-->
  <!--    <mat-tab *ngIf="privilegeTabRegistration.value" label="Registration Reject ({{countRegister}})">-->
  <!--      <ng-template matTabContent>-->
  <!--        <app-registration-reject (totalCount)="handleCountRegistration($event)"-->
  <!--                                 *ngIf="tab === 'registration'"></app-registration-reject>-->
  <!--      </ng-template>-->
  <!--    </mat-tab>-->
  <!--    <mat-tab *ngIf="privilegeTabVerification.value" label="Verification Reject ({{countVerification}})">-->
  <!--      <ng-template matTabContent>-->
  <!--        <app-verification-reject (totalCount)="handleCountVerification($event)"-->
  <!--                                 *ngIf="tab === 'verification'"></app-verification-reject>-->
  <!--      </ng-template>-->
  <!--    </mat-tab>-->
  <!--  </ng-container>-->

  <ng-container *ngFor="let tab of tabList; index as i">
    <mat-tab *ngIf="tab['privilege']" [label]="utilities.mapKeyToString(TabListLabel, tab['labelKey'])">
      <ng-template matTabLabel>{{ utilities.mapKeyToString(TabListLabel, tab['labelKey']) }} ({{ tab['dataCount'] | async }})</ng-template>
      <ng-container *ngIf="i === tabIndex">
        <ng-container *ngComponentOutlet="tab['component']"></ng-container>
      </ng-container>
    </mat-tab>
  </ng-container>
</mat-tab-group>
